module.exports = __webpack_public_path__ + "img/AHS-5277_Community_Hub_FINAL_Logo-01.733d319d.svg";